// extracted by mini-css-extract-plugin
export var component = "HeaderLogo-module--component--cNIR0";
export var link = "HeaderLogo-module--link--Jta3M";